import { render, staticRenderFns } from "./TransfersForAccountant.vue?vue&type=template&id=a87f220e&scoped=true&"
import script from "./TransfersForAccountant.vue?vue&type=script&lang=js&"
export * from "./TransfersForAccountant.vue?vue&type=script&lang=js&"
import style0 from "./TransfersForAccountant.vue?vue&type=style&index=0&id=a87f220e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87f220e",
  null
  
)

export default component.exports